import axios from "axios";

// The browser talks to its own origin in production web, or to https://admin.ownezzy.com/api in native Capacitor app
const isNativePlatform =
  typeof window !== "undefined" &&
  (Boolean(window.Capacitor?.isNativePlatform?.()) ||
    window.location.protocol === "capacitor:" ||
    window.location.protocol === "file:" ||
    (window.location.hostname === "localhost" && window.location.port !== "3000"));

const baseURL =
  process.env.REACT_APP_API_URL ||
  (isNativePlatform ? "https://admin.ownezzy.com/api" : "/api");

export const TOKEN_KEY = "oz_admin_token";
export const USER_KEY = "oz_admin_user";

export const client = axios.create({ baseURL });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers["x-auth-token"] = token;
  return config;
});

// The app registers one handler that signs the user out when the server says the token is no longer valid
let onUnauthorized = () => {};
export const setUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginCall = error.config && /\/auth\/(login|login\/choose|forgot-password|reset-password)$/.test(error.config.url || "");
    if (error.response && error.response.status === 401 && !isLoginCall) onUnauthorized();
    return Promise.reject(error);
  }
);

// Message to show the user: what the API said, or something sensible when it could not be reached
export const errorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  if (err && err.response && err.response.data && err.response.data.message) return err.response.data.message;
  if (err && err.response) return fallback;
  return "Cannot reach the server. Check your connection and try again.";
};

export default client;
